import React from 'react'

const SquadContext = React.createContext({})

export { SquadContext }
